import {IMultiOccurrenceOptions} from '../../../../../core/services/multi-occurrence.service';
import {IFormulaireClass} from '../../../../../core/services/formulaire/formulaire.service';
import {IFormulaireItemClass} from '../../../../../core/services/formulaire/formulaire-item.service';
import { IStateParamsService } from 'angular-ui-router';

interface IPageCP0040 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
}
/* @ngInject */
export default function Cp0040Controller(Formulaire: IFormulaireClass,
                                         FormulaireItem: IFormulaireItemClass,
                                         $stateParams: IStateParamsService) {
    const vm: IPageCP0040 = this;

    vm.multiOccurrenceOptions = {
        fonctions: {
            rechercheCollapsable: false,
            suiviModification: false,
            effaceCriteres: true
        },
        criteresSuggeres: new Formulaire([
            new FormulaireItem('regcleintcri', { 
                default: $stateParams.regcleint,
                readonly: true
            }),
            new FormulaireItem('prucleintcri', { 
                default: $stateParams.prucleint,
                readonly: true
            }),
            new FormulaireItem('prbcleintcri', { 
                default: $stateParams.prbcleint,
                readonly: true
            }),
            new FormulaireItem('prvcleintcri', { 
                default: $stateParams.prvcleint,
                readonly: true
            })
        ]),
        colonnesVisibles: [
            {nom: 'regnumdoc', largeur: 120},
            {nom: 'etddsc', largeur: 150},
            {nom: 'rernomleg', largeur: 250},
            {nom: 'docaffnumdoc01', largeur: 150},
            {nom: 'tydcod', largeur: 120},
            {nom: 'rdomnt', largeur: 126},
            {nom: 'dovimp', largeur: 300},
            {nom: 'dovmnt', largeur: 126},
            {nom: 'taxcod', largeur: 100},
            {nom: 'remcod', largeur: 100},
            {nom: 'dovmntdepnet', largeur: 126}
        ]
    };
}
